export const AP_SECTION_EVENT = 'canvas-agent:ap:section';
export const AP_FILTER_EVENT = 'canvas-agent:ap:filter';
export const AP_FOCUS_EVENT = 'canvas-agent:ap:focus';
export const AP_CREATE_MODAL_EVENT = 'canvas-agent:ap:create-modal';
export const AP_CONFIGURE_MODAL_EVENT = 'canvas-agent:ap:configure-modal';
export const AP_MOVE_MODAL_EVENT = 'canvas-agent:ap:move-modal';
export const AP_REBOOT_MODAL_EVENT = 'canvas-agent:ap:reboot-modal';
export const AP_DELETE_MODAL_EVENT = 'canvas-agent:ap:delete-modal';
export const AP_RADIO_MODAL_EVENT = 'canvas-agent:ap:radio-modal';
export const AP_EDIT_EXPERIENCE_EVENT = 'canvas-agent:ap:edit-experience';
export const AP_BULK_SECTION_EVENT = 'canvas-agent:ap:bulk-section';
